import { useState, useContext, useEffect } from 'react';
import useLocalStorage from './useLocalStorage';
import axios from '../axios';
import { StreakContext } from '../contexts/StreakContext';

const useUser = () => {
	const [isAuthenticated, setIsAuthenticated] = useState(false);
	const { storage } = useLocalStorage('userData');
	const { user, updateUser } = useContext(StreakContext);

	useEffect(() => {
		let fetchUserData = null;
		fetchUserData = async () => {
			if (user === '') {
				if (storage) {
					setIsAuthenticated(true);
					axios.defaults.headers.common.Authorization = `Bearer ${storage.access}`;
				} else {
					setIsAuthenticated(false);
				}
			}
		};
		fetchUserData();
		return () => {
			fetchUserData = null;
		};
	});

	return { user, updateUser, isAuthenticated };
};
export default useUser;
